import { Text, View } from "@react-pdf/renderer";
import { styles } from "../GenericPdf/style";
import { SinglePdfHeaderType } from "../GenericPdf/constant";
import { getMarginValue, handleHeaderDescriptionWidth, handleOthersWidth } from "../CommonPdfComponents/utils";


type AppProps = {
  items: any;
  tableHeaders: SinglePdfHeaderType[];
};

const PurchaseOrderInvoiceTableRow = ({
  items,
  tableHeaders
}: AppProps) => {
  const handleRows = () => {

    const finalItems = items?.map((item: any, index: number) => {
      return (
        <View key={index} style={styles.row}>
          {tableHeaders?.map((header: SinglePdfHeaderType) => {
            if (header?.column_value === "description") {
              return (
                <Text
                  style={{
                    ...styles.description,
                    paddingRight:getMarginValue(tableHeaders?.length),
                    paddingBottom: 1,
                    paddingLeft: "1px",
                    paddingTop: 1,
                    width: handleHeaderDescriptionWidth(tableHeaders?.length),
                    fontSize: "8px",
                  }}
                >
                  {item?.description_as_per_bill
                    ? item?.description_as_per_bill
                    : "-"}
                </Text>
              );
            } else if (header?.column_value === "no") {
              return (
                <Text
                  style={{
                    ...styles.no,
                    paddingBottom: 1,
                    paddingTop: 1,
                    fontSize: "8px" ,
                  }}
                >
                  {index + 1}
                </Text>
              );
            } else if (header?.column_value === "quantity") {
              return (
                <Text
                  style={{
                    ...styles.table_width,
                    paddingRight: "15px",
                    paddingLeft: "0.5px",
                    width: "8%",
                    ...styles.currencyFont,
                    paddingBottom: 1,
                    fontSize: "8px",
                  }}
                >
                  {item[header?.column_value]} {item?.unit ? item?.unit : ""}
                </Text>
              );
            } else {
              return (
                <Text
                  style={{
                    ...styles.table_width,
                    paddingRight:
                      header.column_value === "sku_code" ? "35px" : "30px",
                    paddingLeft: "1px",
                    width:  handleOthersWidth(tableHeaders?.length),
                    ...styles.currencyFont,
                    paddingBottom: 1,
                    fontSize: "8px",
                  }}
                >
                  {header.column_value === "sku_code"
                    ? item[header?.column_value]?.label
                    : item[header?.column_value]?.toString()?.includes(".")
                    ? isNaN(+item[header?.column_value])
                      ? item[header?.column_value]
                      : (+item[header?.column_value])?.toFixed(2)
                    : item[header?.column_value]}
                </Text>
              );
            }
          })}
        </View>
      );
    });

    return finalItems;
  };

  return <View>{handleRows()}</View>;
};

export default PurchaseOrderInvoiceTableRow;
